module.exports = __webpack_public_path__ + "img/katarina_kitchen_11.05d95065.jpg";